<template>
    <div class="goods">
        <div class="head" :class="$iosHeight()">
            <div class="search" >
                <span class="search-icon"></span>
                <input type="text" @click="onSearch" value="请输入搜索关键词" readonly>
            </div>
            <div class="tab">
                <span @click="tab = 1" :class="{'active': tab == 1}">按类目</span>
                <span @click="tab = 2" :class="{'active': tab == 2}">按品牌</span>
            </div>
        </div>
        <div class="heightH" :class="{'heightH1': height === 'isIos', 'heightH2': height === 'isIos2'}"></div>
        <div class="outModel" v-show="tab == 1">
            <Category ref="cate" @scrollTop="getScrollTop"></Category>
        </div>
        <div class="outModel" v-show="tab == 2">
            <ModelList></ModelList>
        </div>
        <Footer :menus='menus'></Footer>
    </div>
</template>
<script>
import ModelList from './common/modelList'
import Category from './common/category'
import Footer from '../../common/footer'
import { mapMutations, mapState } from 'vuex'
import { newCache } from '@/utils/index'
export default {
    name: 'allGoods',
    components: {
        ModelList,
        Category,
        Footer
    },
    data () {
        return {
            menus: 2,
            title: '全部商品',
            tab: 1,
            titleRight: '',
            userInfo: '',
            merchantCode: '',
            tabSidle: [],
            height: 0,
            isStyleType: '',
            scrollY: 0,
            listHeight: [],
            clickIndex: 0
        }
    },
    watch: {
        '$route' (to, from) {
            if (to.name === 'allGoods') { // 跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
                let recruitScrollY = this.getScroll
                this.$nextTick(() => {
                    this.$refs.cate.scrollHeight(recruitScrollY)
                })
            }
        }
    },
    computed: {
        ...mapState({
            getScroll: state => state.recruitScrollY
        })
    },
    beforeRouteEnter (to, from, next) {
        newCache('allGoods')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (to.name === 'goodsList') {
            this.$route.meta.isUseCaChe = false
        } else {
            this.$route.meta.isUseCaChe = true
        }
        let position = this.scrollY
        if (position == null) position = 0
        this.setSCROLL(position)
        next()
    },
    methods: {
        ...mapMutations({
            setSCROLL: 'SCROLL_Y'
        }),
        onBack () {
            this.$router.push('/b2b/home/index')
        },
        onSearch () {
            localStorage.setItem('searchBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/search/index' })
        },
        getScrollTop (val) {
            this.scrollY = val
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        let iosHeight = localStorage.getItem('height')
        this.tab = this.$route.query.tabNav || 1
        if (parseInt(iosHeight) === 64) {
            this.height = 'isIos'
        } else if (parseInt(iosHeight) === 88) {
            this.height = 'isIos2'
        }
    }
}
</script>
<style lang="scss" scoped>
    .heightH{
        height: 176px;
    }
    .heightH1{
        height: 215px;
    }
    .heightH2{
        height: 252px;
    }
    .outModel{
        height: calc(100% - 300px);
        overflow: auto;
    }
    .goods{
        height: 100%;
        font-size: 28px;
        overflow: hidden;
        .head{
            position: fixed;
            padding-top: 16px;
            top: 0;
            left: 0;
            right: 0;
            z-index: 999;
            background: #ffffff;
            .search{
                padding: 0 24px 8px 24px;
                position: relative;
                .search-icon {
                    position: absolute;
                    left: 48px;
                    bottom: 24px;
                    width: 32px;
                    height: 32px;
                    background: url(../../../assets/img/b2b/search.png) no-repeat;
                    background-size: 100% 100%;
                }
                input{
                    height: 64px;
                    line-height: 64px;
                    border-radius: 200px;
                    padding-left: 74px;
                    font-size: 28px;
                    color: #C7C7C7;
                    box-sizing: border-box;
                    background: #f5f5f5;
                }
            }
        }
        .tab{
            height: 88px;
            line-height: 88px;
            text-align: center;
            span{
                display: inline-block;
                width: 188px;
                text-align: center;
                font-size: 28px;
                &.active{
                    color: #FF7A45;
                    border-bottom: 2px solid #FF7A45;
                    font-size: 32px;
                }
            }
        }
    }
</style>